let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g6uwb")).then(() => parcelRequire('bMYxR'));